import {FormControl, FormHelperText, FormLabel, Textarea} from "@mui/joy";
import {useFormContext} from "react-hook-form";

export function FormTextarea({ name, label, size, placeholder, optional, minRows = 3, maxRows = 20, textareaProps, sx, sxTextarea }) {
  const form = useFormContext();
  const error = form.getFieldState(name, form.formState).error;

  return (
    <FormControl error={!!error} sx={sx}>
      {label && <FormLabel>{label} {optional && <span style={{ color: 'var(--joy-palette-neutral-400)' }}>(optional)</span>}</FormLabel>}
      <Textarea {...form.register(name)} size={size} placeholder={placeholder} minRows={minRows} maxRows={maxRows} slotProps={textareaProps ? {textarea: textareaProps} : undefined} sx={sxTextarea}/>
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
}
